import React, { useEffect, useState } from "react";
import NewestCollection from "../../../components/_home/NewestCollection/NewestCollection";
import { newest } from "../../../mock/newest";
import styles from "./Newest.module.scss";

const Newest = () => {
  const [list, setList] = useState(null);
  const [num, setNum] = useState(8);

  useEffect(() => {
    if (newest) {
      if (newest.length > "8") {
        const slicedArray = newest.slice(0, num);
        setList(slicedArray);
      } else {
        setList(newest);
      }
    }
  }, [num]);

  return (
    <section className={styles.container}>
      <div className={styles.subContainer}>
        <h1>Newest Ones</h1>

        <div className={styles.cardsContainer}>
          {list &&
            list.map((i) => (
              <NewestCollection
                key={i.id}
                name={i.name}
                creator={i.creator}
                media={i.media}
                type={i.type}
                price={i.price}
                likes={i.likes}
              />
            ))}
        </div>

        <button
          className={styles.loadMore}
          onClick={() => setNum((num) => num + 4)}
        >
          Load More
        </button>
      </div>
    </section>
  );
};

export default Newest;
